<template>
  <div>
    <h4>
      Filtrar por Parque
      <button @click="selectAllParks()" type="button" class="btn btn-default btn-xs" :disabled="disabled">
        Selecionar todos
      </button>
      <button @click="clearSelectedParks()" type="button" class="btn btn-default btn-xs" :disabled="disabled">
        Limpar
      </button>
    </h4>
    <div class="scrollable-content">
      <div v-for="park in parks" :key="park.id" class="checkbox">
        <label>
          <input v-model="park.isSelected" type="checkbox" :disabled="disabled"> {{ park.name }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ParksFilter',
    props: ['parks', 'disabled'],
    methods: {
      selectAllParks () {
        this.parks.forEach((park) => {
          park.isSelected = true
        })
      },
      clearSelectedParks () {
        this.parks.forEach((park) => {
          park.isSelected = false
        })
      }
    }
  }
</script>

<style scoped>
  .scrollable-content {
    max-height: 477px;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// ParksFilter.vue?42251090